import {
    Address,
    AddressDTO,
    VenueDTO,
    VenueServiceDTO,
    VenueType,
    VenueValues,
} from '../types';

const createVenueAddressAdapter = (adressDTO: AddressDTO): Address => {
    return {
        address1: adressDTO.address_1,
        address2: adressDTO.address_2,
        city: adressDTO.city,
        region: adressDTO.region,
        postalCode: adressDTO.postal_code,
        country: adressDTO.country,
        latitude: adressDTO.latitude,
        longitude: adressDTO.longitude,
        localizedAddress: adressDTO.localized_address_display,
    };
};

export const createVenueAdapter = (venueDTO: VenueDTO): VenueValues => {
    return {
        id: venueDTO.id,
        name: venueDTO.name,
        address: createVenueAddressAdapter(venueDTO.address),
        latitude: venueDTO.latitude,
        longitude: venueDTO.longitude,
        type: VenueType.Venue,
    };
};

export const createVenueServiceDTOAdapter = (
    venue: VenueValues,
    includeGeocodedFields = false,
): VenueServiceDTO => {
    const dto: VenueServiceDTO = {
        name: venue.name,
        address: {
            address_1: venue.address.address1,
            address_2: venue.address.address2,
            city: venue.address.city,
            region: venue.address.region,
            postal_code: venue.address.postalCode,
            country: venue.address.country,
        },
    };

    if (includeGeocodedFields) {
        dto.address.latitude = venue.latitude;
        dto.address.longitude = venue.longitude;
        dto.google_place_id = venue.id;
    }

    return dto;
};
